module.exports = __webpack_public_path__ + "img/노쇠한 고령자(Frail).01543851.png";